import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetOutReachLocationList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/OutReachLocation/GetOutReachLocationList?` + params, null);

export const GetOutReachLocationDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/OutReachLocation/GetOutReachLocationDetail?` + params, null);

// export const CreateOutReachLocation = (data: any) =>
//   POST_ENC(`${BASE_URL}/api/OutReachLocation/CreateOutReach`, data);

// export const UpdateOutReachLocation = (data: any) =>
//   POST_ENC(`${BASE_URL}/api/OutReachLocation/UpdateOutReachLocation`, data);  

// export const DeleteOutReachLocation = (data: any) =>
//   POST_ENC(`${BASE_URL}/api/OutReachLocation/DeleteOutReachLocation`, data);